import React, { useEffect, useState } from "react";
import { Button, Autocomplete, Grid, Box, TextField } from "@mui/material";
import { Formik, Form } from "formik";
// import { useNavigate } from "react-router-dom";
// import { useNavigate } from "react-router-dom";
import UploadIcon from "../../../Icons/Upload.svg";
import Input from "@mui/material/Input";
import "./styles.scss";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";

import {
  getConstitutionOfFirm_action,
  CreateVendor_action,
  getBdUser_action
} from "../../../redux/User/action";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";

import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
// import { getItem } from "../../../utils/crypto";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";

const _initialValues = {
  ReraNumber: "",
  ConstitutionFirm: "",
  VendorName: "",
  vendorEmailID: "",
  PanAvailable: "",
  vendorPanNumber: "",
  vendorGstNumber: "",
  vendorMsmeNumber: "",
  UploadPAN: "",
  Remarks: "",
  ContactPerson: "",
  ContactNumber: "",
  ContactNumber: "",
  GstAvailability: "",
  panAvailability: "",
  MsmeAvailability: "",
  referredBy: ""
};

const validationSchema = yup.object().shape({
  VendorName: yup.string().required("Name is required"),
  referredBy: yup.object().nullable().required("Select the Referred By"),
  ContactNumber: yup
    .string()
    .matches(
      /^[6-9]\d{9}$/,
      "Contact number must be 10 digits and start with a digit from 6 to 9"
    )
    .required("Contact number is required"),

  ContactPerson: yup
    .string()
    .required("Contact Person is required")
    .matches(/^[A-Za-z\s]+$/, "Only letters and spaces are allowed"),
  vendorEmailID: yup
    .string()
    .required("Email is required")
    .matches(
      /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/,
      "Invalid Email format"
    )
  // other fields...
});

// const userLocal = getItem("enuseloc");

// const LoginuserId =
//   userLocal && Object.keys(userLocal).length > 0 ? userLocal["user_id"] : null;
// const UserData = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : null ;
// console.log("UserData", UserData)
function ChannelPartner(props) {
  const formRef = React.useRef(null);
  const [selectedPANFile, setSelectedPANFile] = useState(null);
  const [selectedReraFile, setSelectedReraFile] = useState(null);
  const [selectedRERAFileNOC, setSelectedRERAFileNOC] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);

  const [selectedPANFileNOC, setSelectedPANFileNOC] = useState(null);
  const userList = useSelector((state) => state?.user?.user);

  // const [userList, setUserList] = useState([]);

  const [selectedGSTFileNOC, setSelectedGSTFileNOC] = useState(null);
  const [selectedMEMEileNOC, setSelectedMSMEFileNOC] = useState(null);
  const [selectedMSMEFile, setSelectedMSMEFile] = useState(null);
  const [selectedGSTFile, setSelectedGSTFile] = useState(null);

  const [panAvailability, setPanAvailability] = useState("Yes");
  const [RareAvailability, setRareAvailability] = useState("Yes");
  const [GstAvailability, setGstAvailability] = useState("Yes");
  const [MsmeAvailability, SetMsmeAvailability] = useState("Yes");
  const [visiblePan, setvisiblePan] = useState(true);
  const [visibleRera, setvisibleRera] = useState(true);
  const [visibleGst, setvisibleGst] = useState(true);
  const [visibleMSME, setvisibleMSME] = useState(true);

  const [initialValues, setInitialValues] = useState(_initialValues);
  const [CheckGst, setCheckGst] = useState();
  const [CheckPan, setCheckPan] = useState();
  const [CheckRera, setCheckRera] = useState();
  const [gstError, setGstError] = useState("");
  const [reraError, setReraError] = useState("");
  const [panError, setPanError] = useState("");
  // const navigate = useNavigate();
  const dispatch = useDispatch();

  const getConstitutionOfFirm = useSelector(
    (state) => state?.user?.getConstitutionOfFirm?.data
  );

  const resetFormData = () => {
    setInitialValues({ ..._initialValues });
    setSelectedPANFile(null);
    setSelectedGSTFile(null);
    setSelectedMSMEFile(null);
    setSelectedPANFileNOC(null);
    setSelectedGSTFileNOC(null);
    setSelectedMSMEFileNOC(null);
    setSelectedRERAFileNOC(null);
    setSelectedReraFile(null);
  };
  useEffect(() => {
    const payload = {
      generalSearch: "",
      status: "",
      sortOrder: "",
      iDisplayStart: "0",
      iDisplayLength: "-1"
    };
    dispatch(getConstitutionOfFirm_action(payload));
  }, []);
  const history = useHistory();
  //form Submit
  // import { toast } from 'react-toastify';

  const goBack = () => {
    history.goBack();
  };
  const onSubmit = async (values, action) => {
    // Build payload with clean defaults and no duplicate keys
    const payload = {
      userID: values.referredBy?.user_id || "",
     
      vendorCategory: "ChannelPartner",
      constitutionID: values.ConstitutionFirm?.id || "",
      referenceID: values.referredBy?.user_id || "",
      vendorName: values?.VendorName || "",
      vendorEmailID: values?.vendorEmailID || "",
      vendorPanNumber: values?.vendorPanNumber || "",
      vendorGstNumber: values?.vendorGstNumber || "",
      vendorMsmeNumber: values?.vendorMsmeNumber || "",
      vendorReraNumber: values?.ReraNumber || "",
      isGst: "",
      isPan: "",
      isMsme: "",
      isRera: "",
      contactNumber: values?.ContactNumber || "",
      contactPerson: values?.ContactPerson || "",
      remarks: values?.Remarks || "",
      documentGst: selectedGSTFile,
      documentGstNOC: selectedGSTFileNOC,
      documentPan: selectedPANFile,
      documentPanNOC: selectedPANFileNOC,
      documentMsme: "",
      documentMsmeNOC: "",
      documentRera: selectedReraFile,
      documentReraNOC: selectedRERAFileNOC
    };

    //   action.setSubmitting(true);

    //   try {
    //     const res = await dispatch(CreateVendor_action(payload));

    //     console.log("Response from CreateVendor_action:", res);

    //     if (!res.error) {
    //       toast.success(res.message || "Vendor created successfully!");
    //       action.resetForm({});
    //       history.push("/thank-you-page");
    //     } else {
    //       toast.error(res.message || "Something went wrong.");
    //     }
    //   } catch (error) {
    //     console.error("Error dispatching CreateVendor_action:", error);
    //     toast.error("An unexpected error occurred. Please try again.");
    //   } finally {
    //     action.setSubmitting(false);  // always re-enable the form
    //   }
    // };
    action.setSubmitting(true);

    try {
      const res = await dispatch(CreateVendor_action(payload));

      if (!res.error) {
        toast.success(res.message || "Vendor created successfully!");
        action.resetForm({});
        history.push("/thank-you-page");
      } else {
        toast.error(res.message || "Something went wrong.");
      }
    } catch (error) {
      console.error("Error dispatching CreateVendor_action:", error);
      toast.error("An unexpected error occurred. Please try again.");
    } finally {
      action.setSubmitting(false);
    }
  };

  useEffect(() => {
    if (visibleRera == false) {
      formRef.current.setValues({
        ...formRef.current.values,
        ReraNumber: ""
      });
    }
    if (visibleGst == false) {
      formRef.current.setValues({
        ...formRef.current.values,
        vendorGstNumber: ""
      });
    }
    if (visiblePan == false) {
      formRef.current.setValues({
        ...formRef.current.values,
        vendorPanNumber: ""
      });
    }
  }, [visibleGst, visibleGst, visiblePan, formRef.current]);

  const isImage = (icon) => {
    const ext = [".pdf", ".jpg", ".jpeg", ".png", ".doc"];
    return ext.some((el) => icon.endsWith(el));
  };

  //Img Function
  const handlePanFileClick = (e) => {
    document.getElementById("pan_document_file").click();
  };
  const handleReraFileClick = (e) => {
    document.getElementById("rera_document_file").click();
  };
  const handlePanNocFileClick = (e) => {
    document.getElementById("pan_document_file_Noc").click();
  };
  const handleReraNocFileClick = (e) => {
    document.getElementById("rera_document_file_Noc").click();
  };

  const handleGSTFileClick = (e) => {
    document.getElementById("Gst_document_file").click();
  };
  const handleGSTNOCFileClick = () => {
    document.getElementById("GstNOC_document_file").click();
  };

  const handleMEMEFileClick = () => {
    document.getElementById("MSME_document_file").click();
  };
  const handleMSMENocFileClick = (e) => {
    document.getElementById("MSME_document_file_Noc").click();
  };

  const FileChange = (e, type) => {
    if (e.target.files[0].name && isImage(e.target.files[0].name)) {
      if (type == "panDocument") {
        setSelectedPANFile(e.target.files[0]);
        formRef.current.setValues({
          ...formRef.current.values,
          filePath: e.target.files[0].name
        });
      } else if (type == "panDocumentNOC") {
        setSelectedPANFileNOC(e.target.files[0]);
        formRef.current.setValues({
          ...formRef.current.values,
          filePath: e.target.files[0].name
        });
      }
      if (type == "GstDocument") {
        setSelectedGSTFile(e.target.files[0]);
        formRef.current.setValues({
          ...formRef.current.values,
          filePath: e.target.files[0].name
        });
      } else if (type == "GstDocumentNoc") {
        setSelectedGSTFileNOC(e.target.files[0]);
        formRef.current.setValues({
          ...formRef.current.values,
          filePath: e.target.files[0].name
        });
      }
      // meme
      if (type == "MSMEDocument") {
        setSelectedMSMEFile(e.target.files[0]);
        formRef.current.setValues({
          ...formRef.current.values,
          filePath: e.target.files[0].name
        });
      } else if (type == "MSMEDocumentNoc") {
        setSelectedMSMEFileNOC(e.target.files[0]);
        formRef.current.setValues({
          ...formRef.current.values,
          filePath: e.target.files[0].name
        });
      }
      if (type == "reraDocument") {
        setSelectedReraFile(e.target.files[0]);
        formRef.current.setValues({
          ...formRef.current.values,
          filePath: e.target.files[0].name
        });
      } else if (type == "reraDocumentNOC") {
        setSelectedRERAFileNOC(e.target.files[0]);
        formRef.current.setValues({
          ...formRef.current.values,
          filePath: e.target.files[0].name
        });
      }
    } else {
      if (type == "panDocument") {
        formRef.current.setErrors({
          ...formRef.current.errors,
          panFilePath: "Choose Proper File"
        });
      } else if (type == "panDocumentNOC") {
        formRef.current.setErrors({
          ...formRef.current.errors,
          panNocFilePath: "Choose Proper File"
        });
      }
      if (type == "GstDocument") {
        formRef.current.setErrors({
          ...formRef.current.errors,
          gstFilePath: "Choose Proper File"
        });
      } else if (type == "GstDocumentNoc") {
        formRef.current.setErrors({
          ...formRef.current.errors,
          gstNocFilePath: "Choose Proper File"
        });
      }
      if (type == "MSMEDocument") {
        formRef.current.setErrors({
          ...formRef.current.errors,
          filePath: "Choose Proper File"
        });
      } else if (type == "MSMEDocumentNoc") {
        formRef.current.setErrors({
          ...formRef.current.errors,
          filePath: "Choose Proper File"
        });
      }
      if (type == "reraDocument") {
        formRef.current.setErrors({
          ...formRef.current.errors,
          reraFilePath: "Choose Proper File"
        });
      } else if (type == "reraDocumentNOC") {
        formRef.current.setErrors({
          ...formRef.current.errors,
          reraNocFilePath: "Choose Proper File"
        });
      }
    }
  };
  // useEffect(() => {
  //   if (panAvailability === "No") {
  //     setSelectedPANFile(null);
  //   }
  //   if (RareAvailability === "No") {
  //     setSelectedReraFile(null);
  //   }

  //   if (GstAvailability === "No") {
  //     setSelectedGSTFile(null);
  //   }
  //   if (GstAvailability === "Yes") {
  //     setSelectedGSTFileNOC(null);
  //   }
  //   if (RareAvailability === "Yes") {
  //     setSelectedRERAFileNOC(null);
  //   }
  //   if (panAvailability === "Yes") {
  //     setSelectedPANFileNOC(null);
  //   }
  // }, [panAvailability, GstAvailability, RareAvailability]);
// useEffect(() => {
//     dispatch(getBdUser_action({}));
//     return () => {
//       setUserList([]);
//       dispatch({
//         type: "GET_BD_USER",
//         payload: []
//       });
//     };
//   }, []);

//     useEffect(() => {
//     setUserList(user);
//   }, [user]);

  useEffect(() => {
    const payload = {
      departmentID: "39",
    };
    dispatch(getBdUser_action(payload));
  }, []);
  return (
    <div className="component-list">
      <Grid
        container
        className="d-flex justify-content-between align-items-center"
        py={1}
      >
        <Grid
          item
          className="common-header-label"
          sx={{ alignItems: "center", textAlign: "center" }}
        >
          <Button onClick={goBack} sx={{ color: "#33cb51" }}>
            <MenuOpenIcon />
          </Button>
          Register Channel Partner
        </Grid>

        <Formik
          enableReinitialize
          innerRef={formRef}
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {({
            errors,
            handleSubmit,
            handleChange,
            setFieldValue,
            handleBlur,
            isSubmitting,
            isValid,
            touched,
            values
          }) => (
            <Form onSubmit={handleSubmit}>
              <>
                <Grid container className="component-form">
                  <Grid container>
                   

                       <Grid item xs={12} sm={12} md={12} lg={12} p={1}>
                      <Autocomplete
                        disablePortal
                        id="referredBy"
                        name="referredBy"
                        onBlur={handleBlur}
                        value={values.referredBy}
                        size={"small"}
                        options={userList ? userList : []}
                        getOptionLabel={(option) => option.user_name || ""}
                        renderOption={(props, option) => {
                          return (
                            <li
                              {...props}
                              style={{ textAlign: "left" }}
                              key={option.user_id}
                            >
                              {option.user_name}
                            </li>
                          );
                        }}
                        onChange={(e, value) => {
                          setFieldValue("referredBy", value);
                          setInitialValues({
                            ...initialValues,
                            referredBy: value
                          });
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            fullWidth
                            label="Referred By *"
                            name="referredBy"
                            variant="outlined"
                            helperText={touched.referredBy && errors.referredBy}
                            error={touched.referredBy && Boolean(errors.referredBy)}
                          />
                        )}
                      />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12} p={1}>
                      <Autocomplete
                        name="ConstitutionFirm"
                        value={values.ConstitutionFirm}
                        fullWidth
                        options={
                          getConstitutionOfFirm ? getConstitutionOfFirm : []
                        }
                        onBlur={handleBlur}
                        size="small"
                        getOptionLabel={(item) => item?.constitution_name || ""}
                        onChange={(e, value) => {
                          setFieldValue("ConstitutionFirm", value);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            fullWidth
                            label="Constitution Of Firm"
                            name="ConstitutionFirm"
                            variant="outlined"
                            helperText={
                              errors.ConstitutionFirm && errors.ConstitutionFirm
                            }
                            error={
                              errors.ConstitutionFirm &&
                              Boolean(errors.ConstitutionFirm)
                            }
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} p={1}>
                      <TextField
                        name="VendorName"
                        id="VendorName"
                        fullWidth
                        onBlur={handleBlur}
                        onChange={(e) => {
                          const value = e.target.value.replace(
                            /[^A-Za-z0-9.\s]/g,
                            ""
                          );

                          setFieldValue("VendorName", value);
                        }}
                        value={values?.VendorName}
                        error={errors.VendorName && Boolean(errors.VendorName)}
                        helperText={errors.VendorName && errors.VendorName}
                        size="small"
                        label="Name *"
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} p={1}>
                      <TextField
                        id="vendorEmailID"
                        name="vendorEmailID"
                        value={values?.vendorEmailID}
                        fullWidth
                        onBlur={handleBlur}
                        // onChange={handleChange}
                        onChange={(e) => {
                          setFieldValue("vendorEmailID", e.target.value);
                        }}
                        InputProps={{
                          maxLength: 100
                        }}
                        size="small"
                        label=" Email ID *"
                        variant="outlined"
                        type="email"
                        error={
                          errors.vendorEmailID && Boolean(errors.vendorEmailID)
                        }
                        helperText={
                          errors.vendorEmailID && errors.vendorEmailID
                        }
                      />
                    </Grid>
                    {/*---------------------- Rare Number-------------------- */}
                    <Grid container></Grid>
                    {visibleRera && (
                      <Grid container>
                        <Grid item xs={12} sm={12} md={12} lg={12} p={1}>
                          <TextField
                            name="ReraNumber"
                            fullWidth
                            onBlur={handleBlur}
                            onChange={(e) => {
                              const inputValue = e.target.value.replace(
                                /[^A-Za-z0-9/]/g,
                                ""
                              );
                              setCheckRera(inputValue);
                              if (inputValue.length <= 50) {
                                setFieldValue("ReraNumber", inputValue);
                              }
                            }}
                            value={values.ReraNumber}
                            error={errors.ReraNumber || Boolean(reraError)}
                            helperText={errors.ReraNumber || reraError}
                            id="ReraNumber"
                            label="RERA Number"
                            variant="outlined"
                          />
                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={12} p={1}>
                          <label
                            htmlFor="contained-button-file"
                            className="contained-button-file"
                          >
                            <Button
                              fullWidth
                              className="btn-choose"
                              size="small"
                              variant="outlined"
                              component="span"
                              startIcon={
                                <img src={UploadIcon} height={30} alt={""} />
                              }
                              onClick={() => handleReraFileClick()}
                              sx={{
                                backgroundColor:
                                  selectedReraFile !== null ? "#d1edd1" : ""
                                // border:
                                //   selectedReraFile !== null
                                //     ? " "
                                //     : "1px solid red"
                              }}
                            >
                              <Input
                                sx={{ display: "none" }}
                                accept="image/*"
                                size="small"
                                id="rera_document_file"
                                name="reraDocument"
                                type="file"
                                onChange={(e) => FileChange(e, "reraDocument")}
                              />

                              <div>
                                <div>
                                  {selectedReraFile?.name !== undefined
                                    ? selectedReraFile?.name
                                    : "Upload RERA Documnet"}
                                </div>
                                <div className="common-label-small-grey">
                                  .PDF .Img
                                </div>
                              </div>
                            </Button>

                            {errors?.reraFilePath && (
                              <span
                                className="MuiFormHelperText-root Mui-error MuiFormHelperText-sizeSmall MuiFormHelperText-contained css-k4qjio-MuiFormHelperText-root"
                                style={{ color: "#d32f2f" }}
                              >
                                {errors?.reraFilePath}
                              </span>
                            )}
                          </label>
                        </Grid>
                      </Grid>
                    )}
                    {RareAvailability === "No" && (
                      <Grid item xs={12} sm={12} md={12} lg={12} p={1}>
                        <label
                          htmlFor="contained-button-file"
                          className="contained-button-file"
                        >
                          <Button
                            fullWidth
                            className="btn-choose"
                            size="small"
                            variant="outlined"
                            component="span"
                            startIcon={
                              <img src={UploadIcon} height={30} alt={""} />
                            }
                            onClick={() => handleReraNocFileClick()}
                            sx={{
                              backgroundColor:
                                selectedRERAFileNOC !== null ? "#d1edd1" : ""
                              // border:
                              //   selectedRERAFileNOC !== null
                              //     ? " "
                              //     : "1px solid red"
                            }}
                          >
                            <Input
                              sx={{ display: "none" }}
                              accept="image/*"
                              size="small"
                              id="rera_document_file_Noc"
                              name="reraDocumentNOC"
                              type="file"
                              onChange={(e) => FileChange(e, "reraDocumentNOC")}
                            />

                            <div>
                              <div>
                                {selectedRERAFileNOC?.name !== undefined
                                  ? selectedRERAFileNOC?.name
                                  : "Upload RERA Number NOC"}
                              </div>
                              <div className="common-label-small-grey">
                                .PDF .Img
                              </div>
                            </div>
                          </Button>

                          {errors?.reraNocFilePath && (
                            <span
                              className="MuiFormHelperText-root Mui-error MuiFormHelperText-sizeSmall MuiFormHelperText-contained css-k4qjio-MuiFormHelperText-root"
                              style={{ color: "#d32f2f" }}
                            >
                              {errors?.reraNocFilePath}
                            </span>
                          )}
                        </label>
                      </Grid>
                    )}

                    {visiblePan && (
                      <Grid container>
                        <Grid item xs={12} sm={12} md={12} lg={12} p={1}>
                          <TextField
                            name="vendorPanNumber"
                            fullWidth
                            onBlur={handleBlur}
                            // onChange={handleChange}
                            onChange={(e) => {
                              setCheckPan(e.target.value);
                              const inputValue = e.target.value
                                .toUpperCase()
                                .replace(/[^A-Z0-9]/g, "");

                              if (inputValue.length <= 10) {
                                setFieldValue("vendorPanNumber", inputValue);
                              }
                            }}
                            value={values.vendorPanNumber}
                            error={errors.vendorPanNumber || Boolean(panError)}
                            helperText={errors.vendorPanNumber || panError}
                            id="vendorPanNumber"
                            // size="small"
                            label="PAN Number "
                            variant="outlined"
                          />
                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={12} p={1}>
                          <label
                            htmlFor="contained-button-file"
                            className="contained-button-file"
                          >
                            <Button
                              fullWidth
                              className="btn-choose"
                              size="small"
                              variant="outlined"
                              component="span"
                              startIcon={
                                <img src={UploadIcon} height={30} alt={""} />
                              }
                              onClick={() => handlePanFileClick()}
                              sx={{
                                backgroundColor:
                                  selectedPANFile !== null ? "#d1edd1" : ""
                                // border:
                                //   selectedPANFile !== null
                                //     ? " "
                                //     : "1px solid red"
                              }}
                            >
                              <Input
                                sx={{ display: "none" }}
                                accept="image/*"
                                size="small"
                                id="pan_document_file"
                                name="panDocument"
                                type="file"
                                onChange={(e) => FileChange(e, "panDocument")}
                              />

                              <div>
                                <div>
                                  {selectedPANFile?.name !== undefined
                                    ? selectedPANFile?.name
                                    : "Upload PAN DOCUMENT"}
                                </div>
                                <div className="common-label-small-grey">
                                  .PDF .Img
                                </div>
                              </div>
                            </Button>

                            {errors?.panFilePath && (
                              <span
                                className="MuiFormHelperText-root Mui-error MuiFormHelperText-sizeSmall MuiFormHelperText-contained css-k4qjio-MuiFormHelperText-root"
                                style={{ color: "#d32f2f" }}
                              >
                                {errors?.panFilePath}
                              </span>
                            )}
                          </label>
                        </Grid>
                      </Grid>
                    )}
                    {panAvailability === "No" && (
                      <Grid item xs={12} sm={12} md={12} lg={12} p={1}>
                        <label
                          htmlFor="contained-button-file"
                          className="contained-button-file"
                        >
                          <Button
                            fullWidth
                            className="btn-choose"
                            size="small"
                            variant="outlined"
                            component="span"
                            startIcon={
                              <img src={UploadIcon} height={30} alt={""} />
                            }
                            onClick={() => handlePanNocFileClick()}
                            sx={{
                              backgroundColor:
                                selectedPANFileNOC !== null ? "#d1edd1" : ""
                              // border:
                              //   selectedPANFileNOC !== null
                              //     ? " "
                              //     : "1px solid red"
                            }}
                          >
                            <Input
                              sx={{ display: "none" }}
                              accept="image/*"
                              size="small"
                              id="pan_document_file_Noc"
                              name="panDocumentNOC"
                              type="file"
                              onChange={(e) => FileChange(e, "panDocumentNOC")}
                            />

                            <div>
                              <div>
                                {selectedPANFileNOC?.name !== undefined
                                  ? selectedPANFileNOC?.name
                                  : "Upload PAN NOC"}
                              </div>
                              <div className="common-label-small-grey">
                                .PDF .Img
                              </div>
                            </div>
                          </Button>

                          {errors?.panNocFilePath && (
                            <span
                              className="MuiFormHelperText-root Mui-error MuiFormHelperText-sizeSmall MuiFormHelperText-contained css-k4qjio-MuiFormHelperText-root"
                              style={{ color: "#d32f2f" }}
                            >
                              {errors?.panNocFilePath}
                            </span>
                          )}
                        </label>
                      </Grid>
                    )}
                  </Grid>
                  {visibleGst && (
                    <Grid container>
                      <Grid item xs={12} sm={12} md={12} lg={12} p={1}>
                        <TextField
                          name="vendorGstNumber"
                          fullWidth
                          onBlur={handleBlur}
                          onChange={(e) => {
                            let value = e.target.value
                              .toUpperCase()
                              .replace(/[^A-Z0-9-]/g, "");
                            if (value.length <= 15) {
                              setFieldValue("vendorGstNumber", value);
                              setCheckGst(value);
                            }
                          }}
                          value={values.vendorGstNumber}
                          error={
                            Boolean(errors.vendorGstNumber) || Boolean(gstError)
                          }
                          helperText={errors.vendorGstNumber || gstError}
                          id="vendorGstNumber"
                          label="GST Number"
                          variant="outlined"
                        />
                      </Grid>

                      <Grid item xs={12} sm={12} md={12} lg={12} p={1}>
                        <label
                          htmlFor="contained-button-file"
                          className="contained-button-file"
                        >
                          <Button
                            fullWidth
                            className="btn-choose"
                            size="small"
                            variant="outlined"
                            component="span"
                            startIcon={
                              <img src={UploadIcon} height={30} alt={""} />
                            }
                            onClick={() => handleGSTFileClick()}
                            sx={{
                              backgroundColor:
                                selectedGSTFile !== null ? "#d1edd1" : ""
                              // border:
                              //   selectedGSTFile !== null ? " " : "1px solid red"
                            }}
                          >
                            <Input
                              sx={{ display: "none" }}
                              accept="image/*"
                              size="small"
                              id="Gst_document_file"
                              name="GstDocument"
                              type="file"
                              onChange={(e) => FileChange(e, "GstDocument")}
                            />

                            <div>
                              <div>
                                {selectedGSTFile?.name !== undefined
                                  ? selectedGSTFile?.name
                                  : "UPLOAD GST DOCUMENT"}
                              </div>
                              <div className="common-label-small-grey">
                                .PDF .Img
                              </div>
                            </div>
                          </Button>

                          {errors?.gstFilePath && (
                            <span
                              className="MuiFormHelperText-root Mui-error MuiFormHelperText-sizeSmall MuiFormHelperText-contained css-k4qjio-MuiFormHelperText-root"
                              style={{ color: "#d32f2f" }}
                            >
                              {errors?.gstFilePath}
                            </span>
                          )}
                        </label>
                      </Grid>
                    </Grid>
                  )}
                  {GstAvailability === "No" && (
                    <Grid item xs={12} sm={12} md={12} lg={12} p={1}>
                      <label
                        htmlFor="contained-button-file"
                        className="contained-button-file"
                      >
                        <Button
                          fullWidth
                          className="btn-choose"
                          size="small"
                          variant="outlined"
                          component="span"
                          startIcon={
                            <img src={UploadIcon} height={30} alt={""} />
                          }
                          onClick={() => handleGSTNOCFileClick()}
                          sx={{
                            backgroundColor:
                              selectedGSTFileNOC !== null ? "#d1edd1" : ""
                            // border:
                            //   selectedGSTFileNOC !== null
                            //     ? " "
                            //     : "1px solid red"
                          }}
                        >
                          <Input
                            sx={{ display: "none" }}
                            accept="image/*"
                            size="small"
                            id="GstNOC_document_file"
                            name="GstDocumentNoc"
                            type="file"
                            onChange={(e) => FileChange(e, "GstDocumentNoc")}
                          />

                          <div>
                            <div>
                              {selectedGSTFileNOC?.name !== undefined
                                ? selectedGSTFileNOC?.name
                                : "Upload GST NOC"}
                            </div>
                            <div className="common-label-small-grey">
                              .PDF .Img
                            </div>
                          </div>
                        </Button>

                        {errors?.gstNocFilePath && (
                          <span
                            className="MuiFormHelperText-root Mui-error MuiFormHelperText-sizeSmall MuiFormHelperText-contained css-k4qjio-MuiFormHelperText-root"
                            style={{ color: "#d32f2f" }}
                          >
                            {errors?.gstNocFilePath}
                          </span>
                        )}
                      </label>
                    </Grid>
                  )}

                  <Grid item xs={12} sm={12} md={12} lg={12} p={1}>
                    <TextField
                      name="ContactNumber"
                      id="ContactNumber"
                      fullWidth
                      onBlur={handleBlur}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        setFieldValue("ContactNumber", value);
                      }}
                      value={values?.ContactNumber}
                      inputProps={{
                        maxLength: 10
                      }}
                      error={
                        errors.ContactNumber && Boolean(errors.ContactNumber)
                      }
                      helperText={errors.ContactNumber && errors.ContactNumber}
                      size="small"
                      label="Contact Number *"
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={12} p={1}>
                    <TextField
                      name="ContactPerson"
                      id="ContactPerson"
                      fullWidth
                      onBlur={handleBlur}
                      onChange={(e) => {
                        setFieldValue("ContactPerson", e.target.value);
                      }}
                      value={values?.ContactPerson}
                      error={
                        errors.ContactPerson && Boolean(errors.ContactPerson)
                      }
                      helperText={errors.ContactPerson && errors.ContactPerson}
                      size="small"
                      label="Contact Person *"
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={12} p={1}>
                    <TextField
                      name="Remarks"
                      id="Remarks"
                      fullWidth
                      onBlur={handleBlur}
                      onChange={(e) => {
                        setFieldValue("Remarks", e.target.value);
                      }}
                      value={values?.Remarks}
                      error={errors.Remarks && Boolean(errors.Remarks)}
                      helperText={errors.Remarks && errors.Remarks}
                      size="small"
                      label="Remarks"
                      variant="outlined"
                    />
                  </Grid>
                </Grid>
                {openPopup && (
                  <p style={{ color: "red" }}>
                    You can't Select Both RERA and PAN Available are marked as
                    "No." Please review your selection.
                  </p>
                )}

                <Grid className="d-flex justify-content-start" p={2}>
                  {/* <Box mx={2}>
                    {" "}
                    <Button
                      text="CANCEL"
                      variant="contained"
                      color="secondary"
                      size="medium"
                      type="reset"
                      onClick={() => resetFormData()}
                    >
                      RESET
                    </Button>
                  </Box> */}
                  <Box>
                    {/* <Button onClick={goBack}>Back</Button> */}

                    <Button
                      type="submit"
                      text="SAVE"
                      variant="contained"
                      size="medium"
                    >
                      Submit
                    </Button>
                  </Box>
                </Grid>
              </>
            </Form>
          )}
        </Formik>
      </Grid>
    </div>
  );
}

export default ChannelPartner;
